import { useContext, useEffect, useState } from "react";

import { SearchContext } from "context/providers";
import { getPurifiedParsedMarkDown } from "utils/markdown";
import { getSearchStateQuery } from "utils/helpers/search";

const ParsedResume = ({
  hit,
  parsedResumeHasHighLight,
  resumeHasLocalHighLight,
  localHighlightBasedOnQuery,
}) => {
  const [viewAll, setViewAll] = useState(true);

  useEffect(() => {
    setViewAll(!parsedResumeHasHighLight && !resumeHasLocalHighLight);
  }, [hit, parsedResumeHasHighLight, resumeHasLocalHighLight]);

  const { searchState } = useContext(SearchContext);

  let parsedResume = hit.parsedResume || [];

  const searchStateQuery = getSearchStateQuery(searchState);

  if (!viewAll) {
    if (parsedResumeHasHighLight) {
      if (hit._highlightResult?.parsedResume?.content) {
        parsedResume =
          hit._highlightResult?.parsedResume?.content
            .map((hc) => {
              let value;
              if (localHighlightBasedOnQuery && searchStateQuery && hc.value) {
                value = localHighlightBasedOnQuery(hc.value, searchStateQuery);
              }

              if (
                hc &&
                (hc?.matchLevel !== "none" || /<\/?mark>/g.test(value))
              ) {
                return {
                  content: value || hc.value,
                };
              }

              return null;
            })
            ?.filter((e) => e) || [];
      } else if (Array.isArray(hit._highlightResult?.parsedResume)) {
        parsedResume =
          hit._highlightResult?.parsedResume
            .map((hc) => {
              let value;
              if (
                localHighlightBasedOnQuery &&
                searchStateQuery &&
                hc.content
              ) {
                value = localHighlightBasedOnQuery(
                  hc.content.value,
                  searchStateQuery
                );
              }

              if (
                hc.content &&
                (hc.content?.matchLevel !== "none" || /<\/?mark>/g.test(value))
              ) {
                return {
                  content: value || hc.content.value,
                };
              }

              return null;
            })
            ?.filter((e) => e) || [];
      }
    }

    if (resumeHasLocalHighLight) {
      parsedResume = hit.parsedResume?.filter(
        ({ localHighlighted }) =>
          localHighlighted && /<\/?mark>/g.test(localHighlighted)
      );
    }
  }

  return (
    <div className="flex flex-col gap-2 pl-4">
      {parsedResume.map((chunkResume, index) => {
        return (
          <p
            key={`${hit.id}_parsedResume_${index}`}
            className="prose break-words"
            dangerouslySetInnerHTML={{
              __html: getPurifiedParsedMarkDown(
                (chunkResume.localHighlighted || chunkResume.content)
                  .replace(/<ais-highlight-0000000000>/g, "<mark>")
                  .replace(/<\/ais-highlight-0000000000>/g, "</mark>")
              ),
            }}
          />
        );
      })}
    </div>
  );
};

export default ParsedResume;
